<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  <path fill-rule="evenodd"
    d="M15.7 5.5c-.4-.4-1-.4-1.4 0L8 12l6.4 6.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.3L10.7 12l5.1-5.2c.3-.3.3-.9-.1-1.3z"
    clip-rule="evenodd" />
</svg>